// Note: API call methods...!

const apiCallMethods = {
    GET: "GET",
    POST: "POST",
    DELETE: "DELETE",
    PUT: "PUT"
};

export default apiCallMethods;